import { Camera } from 'lucide-react';

interface PhotoViewerProps {
  photoBefore?: string;
  photoAfter?: string;
  onUploadBefore: (file: File) => void;
  onUploadAfter: (file: File) => void;
}

export function PhotoViewer({ 
  photoBefore, 
  photoAfter, 
  onUploadBefore, 
  onUploadAfter 
}: PhotoViewerProps) {
  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    callback: (file: File) => void
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      callback(file);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5">
      <h3 className="mb-4">Fotografías del Tratamiento</h3>
      
      <div className="grid grid-cols-2 gap-4">
        {/* Foto Antes */}
        <div>
          <label className="block text-sm mb-2 text-gray-700">Foto Antes</label>
          {photoBefore ? (
            <div className="relative aspect-square rounded-lg overflow-hidden bg-gray-100">
              <img 
                src={photoBefore} 
                alt="Antes" 
                className="w-full h-full object-cover"
              />
            </div>
          ) : (
            <label className="flex flex-col items-center justify-center aspect-square rounded-lg border-2 border-dashed border-gray-300 hover:border-[#E91E8C] cursor-pointer bg-gray-50 hover:bg-[#E91E8C]/5 transition-colors">
              <Camera className="w-10 h-10 text-gray-400 mb-2" />
              <span className="text-sm text-gray-500">Subir foto</span>
              <input 
                type="file" 
                accept="image/*" 
                className="hidden"
                onChange={(e) => handleFileChange(e, onUploadBefore)}
              />
            </label>
          )}
        </div>

        {/* Foto Después */}
        <div>
          <label className="block text-sm mb-2 text-gray-700">Foto Después</label>
          {photoAfter ? (
            <div className="relative aspect-square rounded-lg overflow-hidden bg-gray-100">
              <img 
                src={photoAfter} 
                alt="Después" 
                className="w-full h-full object-cover"
              />
            </div>
          ) : (
            <label className="flex flex-col items-center justify-center aspect-square rounded-lg border-2 border-dashed border-gray-300 hover:border-[#E91E8C] cursor-pointer bg-gray-50 hover:bg-[#E91E8C]/5 transition-colors">
              <Camera className="w-10 h-10 text-gray-400 mb-2" />
              <span className="text-sm text-gray-500">Subir foto</span>
              <input 
                type="file" 
                accept="image/*" 
                className="hidden"
                onChange={(e) => handleFileChange(e, onUploadAfter)}
              />
            </label>
          )}
        </div>
      </div>
    </div>
  );
}
